import {Spinner} from '../../components/Spinner/Spinner';

type Props = {
  isLoading?: boolean;
  children?: React.ReactNode;
};
export function PanelStatus(props: Props): React.JSX.Element {
  return (
    <div className="flex items-center justify-between gap-2 rounded-md bg-slate1 px-4 py-2 font-semibold text-slate12">
      {props.children}
      {props.isLoading && <Spinner size="sm" />}
    </div>
  );
}

PanelStatus.displayName = 'PanelStatus';
